import React, { memo, ChangeEvent } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { RATE_TYPE_OPTIONS } from 'apps/rms/constants/shipperRates'
import { IShipperRate, RATE_TYPE } from 'apps/rms/types/shipperRates'
import { TextInput } from 'components/atoms'

interface IRateProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  rateError?: string
  rateTypeError?: string
  disabled?: boolean
}

export const Rate = memo<IRateProps>(
  ({ disabled, onChange, rateError, rateTypeError, value: { minChargeRate, rate } }) => {
    const rateHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onChange({ rate: { ...rate, amount: value } })
    }

    const rateTypeHandler = (e: ISelectOption<RATE_TYPE>) => {
      onChange({
        rate: {
          ...rate,
          rateTypeKey: e.value,
        },
        minChargeRate: e.value === RATE_TYPE['Min Charge'] ? minChargeRate : undefined,
      })
    }
    const minChargeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      onChange({
        minChargeRate: value
          ? { ...minChargeRate, amount: value, rateTypeKey: RATE_TYPE['Min Charge'] }
          : undefined,
      })
    }

    const isRatePerMile = rate?.rateTypeKey === RATE_TYPE.RPM

    return (
      <>
        <div className='col-md-4 col-xs-4'>
          <TextInput
            label='Rate Amount'
            placeholder='Enter rate'
            value={rate?.amount || ''}
            onChange={rateHandler}
            type='number'
            id='shipper-rates-rate-amount'
            dataTest='modal-rate-amount'
            required
            validationMessage={rateError}
            invalid={!!rateError}
            disabled={disabled}
          />
        </div>
        <div className='col-md-4 col-xs-4'>
          <Select
            label='Rate Type'
            options={RATE_TYPE_OPTIONS}
            value={rate?.rateTypeKey}
            onChange={rateTypeHandler}
            dataTest='modal-rate-type'
            required
            validationMessage={rateTypeError}
            invalid={!!rateTypeError}
            disabled={disabled}
          />
        </div>
        {isRatePerMile && (
          <div className='col-md-4 col-xs-4'>
            <TextInput
              label='Min Charge'
              placeholder='Enter min charge'
              value={minChargeRate?.amount || ''}
              onChange={minChargeHandler}
              type='number'
              id='shipper-rates-min-charge'
              dataTest='modal-min-charge'
              disabled={disabled}
            />
          </div>
        )}
      </>
    )
  }
)
